export const navigation = [
  {
    text: 'Inicio',
    path: '/inicio',
    icon: 'home'
  },
  {
    text: 'Usuarios',
    path: '/Usuarios',
    icon: 'user'
  },
  {
    text: 'Pedidos',
    path: '/Pedidos',
    icon: 'orderedlist'
  },
  {
    text: 'PedidosMayorista',
    path: '/PedidosMayorista',
    icon: 'orderedlist'
  },
  {
    text: 'Productos',
    path: '/Productos',
    icon: 'product'
  },
  {
    text: 'Produccion',
    path: '/Produccion',
    icon: 'home'
  },
  {
    text: 'Reportes',
    path: '/ProductosOrden',
    icon: 'file'
  },
  {
    text: 'Envios',
    path: '/Envio',
    icon: 'cart'
  },
  {
    text: 'Resolución Envíos',
    path: '/resolucion-envios',
    icon: 'warning'
  },
  {
    text: 'Configuracion',
    path: '/Configuracion',
    icon: 'checklist'
  }
];

export const navigationCliente = [
  {
    text: 'PedidosMayorista',
    path: '/PedidosMayorista',
    icon: 'orderedlist'
  }
];

export const navigationRepartidor = [
  {
    text: 'Mis Envíos',
    path: '/repartidor/mis-envios',
    icon: 'car'
  }
];
